import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { makeEnvironmentProviders } from '@angular/core';

import { BackendHttpInterceptor } from '@ng-gems/api';

import { ErrorCatcherService } from '@app/core/interceptors/error-catcher.service';
import { HeaderInjectorService } from '@app/core/interceptors/header-injector.service';
import { SpinnerLauncherService } from '@app/core/interceptors/spinner-launcher.service';

export const provideHttpInterceptors = () => {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerLauncherService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BackendHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInjectorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatcherService,
      multi: true,
    },
  ]);
};
